import ImageGalleryItem from '../store/schema/ImageGalleryItem';
import ImagePreviewState from '../store/schema/ImagePreviewState';
import { action } from 'satcheljs';

const setImageGalleryItems = action(
    'setImageGalleryItems',
    (viewState: ImagePreviewState, imageGalleryItems: ImageGalleryItem[]) => ({
        viewState,
        imageGalleryItems,
    })
);

export default setImageGalleryItems;
